import { toFolder } from '../mappers/folder';
export function parseFolders(res, parentId) {
  res.data = (res.data.category.children || []).map(folder => toFolder(folder, parentId));
  return res;
}